import React from 'react';
import { ContainerIconButton, ContainerIconButtonLink, IconButtonIcon } from './styles';

// Button components that are only a single icon with no text

export const RoundIconButton = ({ icon, onClick, title, id, spinner, disabled, isAPIButton, isSmall }) => {
  return (
    <ContainerIconButton
      id={id}
      title={title}
      onClick={onClick}
      disabled={disabled}
      isAPIButton={isAPIButton}
      isSmall={isSmall}
    >
      <IconButtonIcon icon={icon} spinner={spinner} isAPIButton={isAPIButton}></IconButtonIcon>
    </ContainerIconButton>
  );
};

export const RoundIconButtonLink = ({ icon, link, title, id }) => {
  return (
    <ContainerIconButtonLink id={id} title={title} href={link} target="_blank" rel="noopener noreferrer">
      <IconButtonIcon icon={icon}></IconButtonIcon>
    </ContainerIconButtonLink>
  );
};
